import { AuthSelectors } from '@store/auth';
import { AppCoreSelectors } from '@store/app-core';
import { SettingsSelectors } from '@store/settings';

export const APP_SELECTORS = [AppCoreSelectors, AuthSelectors, SettingsSelectors];
